import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import maskImage from 'assets/images/explore-learnings/menu/mask-skill-detail.svg'
import searchBarBackground from 'assets/images/explore-learnings/skills/search-back-image.png'
import sparkIcon from 'assets/images/explore-learnings/spark-icon.svg'

import { HeaderTabs } from './HeaderTabs'
import { SearchBar } from './SearchBar'
import { MASK_POSITION_CLASS, HeaderPage } from '../constants/header.constants'
import { useBodyOverflowHidden } from '../hooks/useBodyOverflowHidden'

interface SkillPageSearchHeaderProps {
  page: HeaderPage
  search?: string
}

const SkillPageSearchHeader: React.FC<SkillPageSearchHeaderProps> = ({ page, search }) => {
  const [searchOpen, setSearchOpen] = useState(false)
  let navigate = useNavigate()
  useBodyOverflowHidden(searchOpen)

  const setPage = (page: HeaderPage) => {
    navigate(`/explore-learnings/${page}`, {
      state: { from: '/skill' },
    })
  }

  const isSearch = Boolean(search)
  const maskimageCss = `[mask-image:linear-gradient(90deg,_rgba(0,_0,_0,_1)_calc(100%_-_1280px),_rgba(0,_0,_0,_0)_calc(100%_-_1240px)),var(--mask-url)]
  [mask-size:100%_100%,1280px_100%] 
  ${MASK_POSITION_CLASS[page]}`

  const bgClass = isSearch
    ? `bg-[image:var(--image-url)] bg-cover bg-no-repeat ${maskimageCss}`
    : 'bg-[image:var(--image-url)]'

  const height = isSearch ? 'h-[56px]' : 'h-[74px]'

  return (
    <>
      <div className="sticky top-16 z-30">
        <div className={`relative z-20 flex ${height} px-20 py-[10px] bg-[#fafafa]`}>
          <div
            style={
              {
                '--image-url': `url(${searchBarBackground})`,
                '--mask-url': `url(${maskImage})`,
              } as React.CSSProperties
            }
            className={`absolute inset-0 header-mask h-full -z-1 bgClass bg-cover bg-no-repeat bg-bottom ${bgClass}`}
          />
          <div className="flex justify-between w-full">
            <div className="self-center">
              {isSearch ? (
                <img src={sparkIcon} alt="Spark Icon" className="h-[36px] w-[36px] mr-2 transition-discrete" />
              ) : (
                <img src={sparkIcon} alt="Spark Icon" className="h-10 w-10 mr-2 transition-discrete" />
              )}
            </div>
            {search && <HeaderTabs onChange={setPage} className="items-end" />}
          </div>
        </div>
        <div className="absolute top-1/2 -translate-y-1/2 left-36 z-30">
          <SearchBar setIsOpen={setSearchOpen} page={page} />
        </div>
      </div>
      {searchOpen && <div className="bg-[#191919] opacity-75 w-full h-full fixed top-0 left-0 z-10" />}
    </>
  )
}

export default SkillPageSearchHeader
